import React from 'react'
import Switch from 'react-switch'
import ClassNames from 'classnames'
import { default as VARIABLES } from '../../themes/styles/variables'
import { SwicthStyle } from './styled'
export const Toggle = ({
  handleTofuChange,
  checkedToggle,
  checkedIcon,
  uncheckedIcon,
  className,
  disabled,
}) => {
  const [checked, setChecked] = React.useState(false)
  const handleChange = nextChecked => {
    setChecked(nextChecked)
    handleTofuChange(nextChecked)
  }
  React.useEffect(() => {
    let mount = true
    if (mount) {
      setChecked(checkedToggle)
    }
    return () => {
      mount = false
    }
  }, [checkedToggle])
  return (
    <SwicthStyle className={ClassNames('switch-wrapper', className)}>
      <Switch
        onChange={handleChange}
        checked={checked}
        checkedIcon={checkedIcon}
        uncheckedIcon={uncheckedIcon}
        className="react-switch"
        handleDiameter={8}
        height={16}
        width={27}
        offColor={VARIABLES.COLORS.GRAY_5}
        onColor={VARIABLES.COLORS.GREEN_3}
        disabled={disabled}
      />
    </SwicthStyle>
  )
}
Toggle.defaultProps = {
  handleTofuChange: () => {
    return false
  },
  checkedToggle: false,
  checkedIcon: false,
  uncheckedIcon: false,
  disabled: false,
}
